/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable import/no-duplicates */
/* eslint-disable no-plusplus */
/* eslint-disable no-debugger */
import React, { useState, useEffect } from 'react';
import { Input, Table, Button, Select, Tag, Dropdown, Space, message, Tooltip, Popconfirm, Avatar, Menu } from 'antd';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import UilTimesCricle from '@iconscout/react-unicons/icons/uil-times-circle';
import moment from 'moment';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import { DownloadOutlined, DownOutlined, EyeOutlined, ScissorOutlined } from '@ant-design/icons';
import { pdf } from '@react-pdf/renderer';

import PrintDialog from './PrintDialog';
import ImageCropper from './image-cropper';
import { TableWrapper } from '../../../container/styled';
import { BtnWithIcon, Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { CompSelector, EmpCardPrint, EmpCardSamplePrint, ImagePreview } from '../../common';
import { API_ENDPOINT, CARD_STATUS_COLORS, CARD_STATUSES, CARD_STATUSES_FOR_PRINTING_OPERATOR } from '../../../config/config';
import { themeColor } from '../../../config/theme/themeVariables';

const QRCode = require('qrcode')

const { Option } = Select;

function DataTable() {
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [busy, setBusy] = useState(false);
  const [reloadTable, setReloadTable] = useState(false);
  const [cardStatus, setCardStatus] = useState(1);
  const [reload, setReload] = useState(false);
  const [compID, setCompID] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]); // State to store selected rows
  const [selectedCard, setSelectedCard] = useState(null); // State to store selected rows
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/e-card/query', {
        page: currentPage,
        pageSize,
        search,
        card_status: cardStatus,
        comp_id: compID
      });
      const { data, total } = response.data;
      setTableData(data);
      setTotalRows(total);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleExportCsv = () => {
    const formattedData = tableData.map((item) => {
      return ({
        ...item,
        created_at: moment(item.created_at).format('DD-MM-YYYY hh:mm a'),
      })
    });

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportCsv(tCols, formattedData, `Employees_${moment().format('DD-MM-YYYY')}`);
  };

  const handleExportPdf = () => {
    const formattedData = tableData.map((item) => {
      return ({
        ...item,
        created_at: moment(item.created_at).format('DD-MM-YYYY hh:mm a'),
      })
    });

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportPdf(tCols, formattedData, `Employees_${moment().format('DD-MM-YYYY')}`);
  };

  useEffect(() => {
    fetchTableData();
    if (reload) {
      setReload(false)
      setBusy(false)
    }
    // }, [currentPage, pageSize, search, reload, compID]);
  }, [currentPage, pageSize, reload, compID, search]);

  const exportMenuItems = [
    {
      label: 'Export CSV',
      key: 1,
      icon: <DownloadOutlined />,
    },
    {
      label: 'Export PDF',
      key: 2,
      icon: <DownloadOutlined />,
    },
  ];

  const handleExportMenuClick = (event) => {
    let { key } = event;
    key = Number(key)
    if (key === 1) {
      handleExportCsv();
    } else if (key === 2) {
      handleExportPdf();
    }
  };

  const handlePrintCertificate = async (event) => {
    try {

      setBusy(true)
      const cardIDs = [];
      selectedRows.map(item => cardIDs.push(item.id))
      const response = await DataService.post('/e-card/print-certificate', { card_ids: cardIDs.join(',') });

      const { status, data } = response.data;
      if (status) {
        const { cards, issuance_authority } = data
        for (let index = 0; index < cards.length; index++) {
          const element = cards[index];

          const qrURL = `${window.origin}/pubcert/${(element.encrypted_key)}`
          const qrURI = QRCode.toDataURL(qrURL, { errorCorrectionLevel: 'M', margin: 1 })
          cards[index].qrCode = qrURI

          cards[index].issue_date = moment(element.issue_date).format('D-MM-YYYY')
          cards[index].valid_upto = moment(element.valid_upto).format('D-MM-YYYY')

          cards[index].picture = `${API_ENDPOINT}/${element.emp_picture}`
        }
        const blob = await pdf(
          <EmpCardPrint
            cards={data.cards}
            issuanceAuthority={`${API_ENDPOINT}/${issuance_authority}`}
          />
        ).toBlob();
        // Trigger download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `e_card_${moment().format('DMMYYYY_hh:mm_a')}.pdf`;

        link.click();
        setReload(true)
        message.success(response.data.message)
      } else {
        message.error(response.data.message)
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const hanldePrintSamples = async (event) => {
    try {

      setBusy(true)
      const cardIDs = [];
      selectedRows.map(item => cardIDs.push(item.id))
      const response = await DataService.post('/e-card/print-certificate-samples', { card_ids: cardIDs.join(',') });

      const { status, data } = response.data;
      if (status) {
        const { cards, issuance_authority } = data
        for (let index = 0; index < cards.length; index++) {
          const element = cards[index];

          const qrURL = `${window.origin}/pubcert/${(element.encrypted_key)}`
          const qrURI = QRCode.toDataURL(qrURL, { errorCorrectionLevel: 'M', margin: 1 })
          cards[index].qrCode = qrURI

          cards[index].issue_date = moment(element.issue_date).format('D-MM-YYYY')
          cards[index].valid_upto = moment(element.valid_upto).format('D-MM-YYYY')

          cards[index].picture = `${API_ENDPOINT}/${element.emp_picture}`
        }
        const blob = await pdf(
          <EmpCardSamplePrint
            cards={data.cards}
            issuanceAuthority={`${API_ENDPOINT}/${issuance_authority}`}
          />
        ).toBlob();
        // Trigger download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `e_card_${moment().format('DMMYYYY_hh:mm_a')}.pdf`;

        link.click();
        setReload(true)
        message.success(response.data.message)
      } else {
        message.error(response.data.message)
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const hanldePrintCropped = async (croppedImage) => {
    try {
      if (!selectedCard) return message.error("No any record selected")
      setBusy(true)
      const cardIDs = [selectedCard.id];
      const response = await DataService.post('/e-card/print-certificate-samples', { card_ids: cardIDs.join(',') });

      const { status, data } = response.data;
      if (status) {
        const { cards, issuance_authority } = data
        for (let index = 0; index < cards.length; index++) {
          const element = cards[index];
          cards[index].issue_date = moment(element.issue_date).format('D-MM-YYYY')
          cards[index].valid_upto = moment(element.valid_upto).format('D-MM-YYYY')
          cards[index].picture = croppedImage
        }

        const blob = await pdf(
          <EmpCardSamplePrint
            cards={data.cards}
            issuanceAuthority={`${API_ENDPOINT}/${issuance_authority}`}
          />
        ).toBlob();
        // Trigger download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `e_card_${moment().format('DMMYYYY_hh:mm_a')}.pdf`;

        link.click();
        setReload(true)
        message.success(response.data.message)
      } else {
        message.error(response.data.message)
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const hanldeUpdateCropeedImage = async (croppedImage, reprocessAI) => {
    try {
      if (!selectedCard) return message.error("No any record selected")
      setBusy(true)
      const payload = new FormData();
      const cardID = selectedCard.id;
      // Convert base64 to Blob
      const blob = await fetch(croppedImage).then(res => res.blob());
      const file = new File([blob], `cropped_image_${cardID}.png`, { type: "image/png" });

      payload.append('image', file);
      payload.append('card_id', cardID);
      payload.append('re_process', Number(reprocessAI));

      const response = await DataService.post('/e-card/update-employee-image', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });

      const { status } = response.data;
      if (status) {
        message.success(response.data.message)
        setReload(true)
        setIsCropModalOpen(false)
      } else {
        message.error(response.data.message)
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const handleRejectClick = async (event) => {
    try {
      debugger;
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setBusy(true)
        const response = await DataService.post('/e-card/change-status', { card_id: dataID, status_id: CARD_STATUSES.REJECTED });
        const { status } = response.data;
        if (status) {
          setReload(true)
          message.success(response.data.message)
        } else {
          message.error(response.data.message)
        }
        setBusy(false)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      // setBusy(false)
    }
  }

  const handleMenuClick = (key, profile_picture, rowData) => {
    setSelectedCard(rowData)
    if (key === "preview") {
      setProfilePicture(profile_picture);
      setIsImageModalOpen(true);
    } else if (key === "crop") {
      setProfilePicture(profile_picture);
      setIsCropModalOpen(true);
    }
  };

  const imageMenu = (profile_picture, rowData) => (
    <Menu onClick={({ key }) => handleMenuClick(key, profile_picture, rowData)}>
      <Menu.Item key="preview" icon={<EyeOutlined />}>
        Preview Image
      </Menu.Item>
      <Menu.Item key="crop" icon={<ScissorOutlined />}>
        Crop Image
      </Menu.Item>
    </Menu>
  );

  const renderProfilePicture = (profile_picture, rowData) => {
    return (
      <Dropdown overlay={imageMenu(`${API_ENDPOINT}/${profile_picture}`, rowData)} trigger={['contextMenu', 'click']}>
        <Avatar
          className='cursor-pointer'
          src={profile_picture ? `${API_ENDPOINT}/${profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
          size={40}
        // onClick={() => {
        //   setProfilePicture(`${API_ENDPOINT}/${profile_picture}`);
        //   setIsImageModalOpen(true);
        // }}
        />
      </Dropdown>
    );
  };

  const exportMenuProps = {
    items: exportMenuItems,
    onClick: handleExportMenuClick,
  };

  const TableColumns = [
    {
      title: 'Ori: Img',
      dataIndex: 'profile_picture',
      key: 'profile_picture',
      field: 'profile_picture',
      export: false,
      onCell: () => ({ className: 'w-20 text-center' }),
      render: renderProfilePicture,

      // render: (profile_picture) => {
      //   return (<Avatar
      //     className='cursor-pointer'
      //     key={(Math.random() * 3400) + 200}
      //     src={profile_picture ? `${API_ENDPOINT}/${profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
      //     size={40}
      //     onClick={(event) => {
      //       if (profile_picture) {
      //         setProfilePicture(`${API_ENDPOINT}/${profile_picture}`)
      //         // setIsImageModalOpen(true)
      //         setIsCropModalOpen(true)
      //       } else {
      //         message.info('No profile image');
      //       }
      //     }}
      //   />)
      // },
    },
    {
      title: 'AI: Img',
      dataIndex: 'card_picture',
      key: 'card_picture',
      field: 'card_picture',
      export: false,
      onCell: () => ({ className: 'w-20 text-center' }),
      render: renderProfilePicture,
      // render: (profile_picture) => {
      //   return (<Avatar
      //     className='cursor-pointer'
      //     key={(Math.random() * 3400) + 200}
      //     src={profile_picture ? `${API_ENDPOINT}/${profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
      //     size={40}
      //     onClick={(event) => {
      //       if (profile_picture) {
      //         setProfilePicture(`${API_ENDPOINT}/${profile_picture}`)
      //         setIsImageModalOpen(true)
      //       } else {
      //         message.info('No profile image');
      //       }
      //     }}
      //   />)
      // },
    },
    {
      title: 'Employee Name',
      dataIndex: 'name',
      key: 'name',
      field: 'name',
      export: true,
    },
    {
      title: 'EMP CNIC',
      dataIndex: 'emp_cnic',
      key: 'emp_cnic',
      field: 'emp_cnic',
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },

    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      field: 'contact',
      onCell: () => ({ className: 'w-40 text-center' }),
      export: true,
    },
    {
      title: 'Company',
      dataIndex: 'comp_name',
      key: 'comp_name',
      field: 'comp_name',
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },
    {
      title: 'CreatedAt',
      dataIndex: 'created_at',
      key: 'created_at',
      field: 'created_at',
      onCell: () => ({ className: 'w-28 text-center' }),
      export: true,
      render: (text) => moment(text).format('D-MM-YY hh:mm a'),
    },
    // {
    //   title: 'AI Processed',
    //   dataIndex: 'isWhiteBG',
    //   key: 'isWhiteBG',
    //   field: 'isWhiteBG',
    //   export: true,
    //   width: '10%',
    //   render: (isWhiteBG) => {
    //     let color = themeColor['warning-color']
    //     let lblStr = 'Not Processed';

    //     if (Number(isWhiteBG) === 1) {
    //       lblStr = 'Processed'
    //       color = themeColor['success-color']
    //     }

    //     if (Number(isWhiteBG) === 2) {
    //       lblStr = 'Error'
    //       color = themeColor['error-color']
    //     }

    //     return (
    //       <div className="flex justify-content-center" key={(Math.random() * 3100) + 200}>
    //         <div className='taglist-wrap select-none'>
    //           <Tag color={color}>{lblStr}</Tag>
    //         </div>
    //       </div>
    //     )
    //   },
    // },
    {
      title: 'IsActive',
      dataIndex: 'is_active',
      key: 'is_active',
      field: 'is_active',
      onCell: () => ({ className: 'w-10' }),
      export: true,
      render: (is_active) => {
        let color = themeColor['danger-color']
        let lblStr = 'InActive';

        if (Boolean(is_active)) {
          lblStr = 'Active'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center" key={(Math.random() * 3100) + 200}>
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'card_status',
      key: 'card_status',
      field: 'card_status',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (card_status) => {
        card_status = Number(card_status);
        try {
          const { color, label } = CARD_STATUS_COLORS[card_status]
          return (
            <div className="flex justify-content-center" key={(Math.random() * 3000) + 200}>
              <div className='taglist-wrap select-none'>
                <Tag color={color}>{label}</Tag>
              </div>
            </div>
          )
        } catch (error) {
          return <p>Undefined</p>
        }
      },
    },
    {
      title: 'Actions',
      export: false,
      width: 10,
      render: (rowData) => {
        // console.log('rowData', rowData)
        return (<div className='flex flex-row justify-center select-none' key={(Math.random() * 4100) + 200}>
          {(Number(rowData.card_status) === CARD_STATUSES.IN_PROCESS) && <>
            <Tooltip title='Reject request' className='select-none'>
              <Popconfirm
                title='Are you sure to reject this printing request ?'
                onConfirm={handleRejectClick}
                okButtonProps={{
                  'data-index': rowData.id,
                  disabled: busy
                }}
                okText="Yes"
                cancelText="No"
              >
                <BtnWithIcon
                  onClick={handleRejectClick}
                  className='ninjadash-delete'>
                  <UilTimesCricle
                    className='ninjadash-delete hover:scale-110 hover:text-red-500 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                </BtnWithIcon>
              </Popconfirm>
            </Tooltip>
          </>}
        </div >
        )
      },
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRowsData) => {
      const finalArray = []
      selectedRowsData.map(item => {
        if (Number(item.card_status) === CARD_STATUSES.IN_PROCESS) {
          finalArray.push(item)
        }
      })
      setSelectedRows(finalArray); // Update state with selected rows
    },
    getCheckboxProps: (record) => ({
      disabled: Number(record.card_status) !== CARD_STATUSES.IN_PROCESS, // Example for disabling rows
      name: record.name,
    }),
  };

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Employee e-Cards" routes={[]} />
      <Main>
        <ImagePreview
          visible={isImageModalOpen}
          imageSrc={profilePicture}
          onClose={() => {
            setProfilePicture(null)
            setIsImageModalOpen(false)
          }}
        />
        {/* Image Cropper Modal */}
        <ImageCropper
          visible={isCropModalOpen}
          imageSrc={profilePicture}
          onClose={() => {
            setSelectedCard(null)
            setIsCropModalOpen(false)
          }}
          onPrintSample={hanldePrintCropped}
          onSave={hanldeUpdateCropeedImage}
          busy={busy}
          // onSave={(croppedImage) => {
          //   setProfilePicture(croppedImage);
          //   setIsCropModalOpen(false);
          // }}
          showIDPrint
        />
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <Input
              className=" hover:drop-shadow-xl hover:border-solid hover:border-1 hover:border-blue-800 rounded-sm w-1/4"
              size='small'
              autoFocus
              placeholder="Search Anything"
              prefix={<UilSearch size={15} />}
              defaultValue={search}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <div className="flex space-x-2">
              <div className="min-w-60">
                <CompSelector onItemSelected={setCompID} placeholder='Filter By Company' defaultSize='small' />
              </div>

              <Select
                placeholder="Card Status"
                className='w-40'
                value={cardStatus}
                onChange={(value) => {
                  setCardStatus(value)
                  setTimeout(() => {
                    setReload(true)
                  }, 200);
                }}
              >
                {Object.entries({ ...CARD_STATUSES_FOR_PRINTING_OPERATOR }).map(([key, value], index) => (
                  <Option key={value} value={value}>
                    {key}
                  </Option>
                ))}
              </Select>

              <Dropdown menu={exportMenuProps}>
                <Button className='h-9'>
                  <Space>
                    Export Data
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
              {/* <Tooltip title='Reject request' className='select-none'>
                <Popconfirm
                  title='Please confirm your action !'
                  onConfirm={handlePrintCertificate}
                  okText="Yes, Confirmed"
                  cancelText="No, Cancel"
                >
                  <Button
                    type="primary"
                    className='flex text-center h-auto items-center'
                    loading={busy}
                    disabled={selectedRows.length < 1}>
                    <UilPrint /> &nbsp;&nbsp; Print Cards &nbsp;
                  </Button>
                </Popconfirm>
              </Tooltip> */}

              {/* <Button
                type="primary"
                onClick={handlePrintCertificate}
                className='flex text-center h-auto items-center'
                loading={busy}
                disabled={selectedRows.length < 1}>
                <UilPrint /> &nbsp;&nbsp; Print Cards &nbsp;
              </Button> */}
              <PrintDialog
                handlePrintCertificate={handlePrintCertificate}
                selectedRows={selectedRows}
                hanldePrintSamples={hanldePrintSamples}
              />
            </div>
          </div>
          <div className="ninjadasj-datatable">
            <TableWrapper>
              <Table
                rowKey={(record) => `${record.id}-${record?.card_status}`} // Generate a unique key for each row
                key={`${currentPage}-${pageSize}`} // Add a unique key to force re-render
                loading={busy}
                bordered
                virutal
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                // scroll={{ x: 'max-content', y: 400 }} // Add this to control scroll dimensions
                dataSource={tableData}
                columns={TableColumns}
                rowSelection={{
                  type: 'checkbox', // or 'radio'
                  ...rowSelection,
                }}
              />
            </TableWrapper>
          </div>
        </div>
      </Main>
    </>
  );
}

export default DataTable;
